import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css/skyblue";
import "@splidejs/react-splide/css/core";

const Carousel = () => {
  return (
    <>
      <Splide
        hasTrack={false}
        options={{
          type: "fade",
          rewind: true,
          autoplay: "playing",
          arrows: false,
          drag: false,
          pagination: false,
          perPage: 1,
        }}
        aria-label="My Favorite Images"
        className="relative h-[50vh] w-full"
      >
        <SplideTrack className="absolute w-full h-full ">
          <SplideSlide className="w-full h-full">
            <img
              className="w-full h-full object-cover"
              src={process.env.PUBLIC_URL + "/images/banniere1.jpg"}
              alt="banniere 1"
            />
          </SplideSlide>

          <SplideSlide className="w-full h-full">
            <img
              className="w-full h-full object-cover"
              src={process.env.PUBLIC_URL + "/images/banniere2.jpg"}
              alt="banniere 2"
            />
          </SplideSlide>

          <SplideSlide className="w-full h-full">
            <img
              className="w-full h-full object-cover"
              src={process.env.PUBLIC_URL + "/images/banniere3.jpg"}
              alt="banniere 2"
            />
          </SplideSlide>
        </SplideTrack>
      </Splide>
    </>
  );
};

export default Carousel;
